export default "__VITE_ASSET__D9v41QZ1__"